import { Button, Form, Row } from "antd";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import PermissionCheck from "../../Common/PermissionCheck";
import { useCreateMatchProfile, useUpdateMatchProfile } from "../../entities/api";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import FormContent from "./FormsBySport/FormContent";
import formatFormData from "./Utility/formatFormData";
import getInitFormValues from "./Utility/getInitFormValues";

const PermissionName = PermissionNames.MATCH_PROFILE;

const ManageMatchProfileForm = ({ matchProfile = null }) => {
  const [form] = Form.useForm();
  const { sport, matchProfileId } = useParams();
  const { formatMessage } = useIntl();
  const { mutate: createFn, isPending: isCreatePending } = useCreateMatchProfile();
  const { mutate: updateFn, isPending: isUpdatePending } = useUpdateMatchProfile();

  const handleRequest = async (type) => {
    const data = await form.validateFields();
    const formattedData = formatFormData({ data, type: "server", sport });

    if (type === "add") {
      createFn(formattedData);
    }

    if (type === "update") {
      updateFn(formattedData);
    }
  };

  return (
    <>
      <Form
        className={"mt-4"}
        // initialValues={getInitValues(sport, matchProfile)}
        initialValues={getInitFormValues({ sport, matchProfile })}
        form={form}
        colon={false}
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 24 }}
        labelWrap
      >
        <FormContent sport={sport} form={form} />
      </Form>
      <Row justify={"center"}>
        {matchProfileId ? (
          <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.UPDATE]}>
            <Button loading={isUpdatePending} onClick={() => handleRequest("update")} size={"large"} type={"primary"}>
              {formatMessage({
                id: "update",
                defaultMessage: "Update",
              })}
            </Button>
          </PermissionCheck>
        ) : (
          <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.CREATE]}>
            <Button loading={isCreatePending} onClick={() => handleRequest("add")} size={"large"} type={"primary"}>
              {formatMessage({ id: "add", defaultMessage: "Add" })}
            </Button>
          </PermissionCheck>
        )}
      </Row>
    </>
  );
};

export default ManageMatchProfileForm;
